// import { createAction } from '@reduxjs/toolkit';
import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const marketplacePartnerOnboardingSignupDataModuleActions =
    createDataModuleActions('MARKETPLACE_PARTNER_ONBOARDING_SIGNUP');

export const marketplacePartnerOnboardingSignup =
    marketplacePartnerOnboardingSignupDataModuleActions.dataRequest;
export const marketplacePartnerOnboardingSignupSuccess =
    marketplacePartnerOnboardingSignupDataModuleActions.dataSuccess;
export const marketplacePartnerOnboardingSignupError =
    marketplacePartnerOnboardingSignupDataModuleActions.dataError;
export const marketplacePartnerOnboardingSignupReset =
    marketplacePartnerOnboardingSignupDataModuleActions.dataReset;

// TODO: uncomment when verify phone will be integrated
// export const completeSignupRequirements = createAction(
//     'backend/STORE::COMPLETE_SIGNUP_REQUIREMENTS',
// );

const fetchMarketplaceSummaryForOnboardingActions = createDataModuleActions(
    'FETCH_MARKETPLACE_SUMMARY_FOR_ONBOARDING',
);
export const fetchMarketplaceSummaryForOnboarding =
    fetchMarketplaceSummaryForOnboardingActions.dataRequest;
export const fetchMarketplaceSummaryForOnboardingSuccess =
    fetchMarketplaceSummaryForOnboardingActions.dataSuccess;
export const fetchMarketplaceSummaryForOnboardingError =
    fetchMarketplaceSummaryForOnboardingActions.dataError;

const submitMarketplaceCardApplicationActions = createDataModuleActions(
    'SUBMIT_MARKETPLACE_CARD_APPLICATION',
);
export const submitMarketplaceCardApplication =
    submitMarketplaceCardApplicationActions.dataRequest;
export const submitMarketplaceCardApplicationSuccess =
    submitMarketplaceCardApplicationActions.dataSuccess;
export const submitMarketplaceCardApplicationError =
    submitMarketplaceCardApplicationActions.dataError;
export const submitMarketplaceCardApplicationReset =
    submitMarketplaceCardApplicationActions.dataReset;
